import { format, parseISO, startOfToday } from 'date-fns';

// Mirrors Title1.Server.Models.Enums.TeachingSubject
export const Subject = {
    Reading: 1,
    Math: 2
};

export const SubjectLabel = {
    [Subject.Reading]: 'ELA',
    [Subject.Math]: 'Math'
};

// Mirrors Title1.Server.Models.Enums.AssessmentType
export const AssessmentType = {
    Other: 0,
    IReady: 1,
    FountasAndPinnell: 2,
    GoMath: 3
};

export const AssessmentTypeLabel = {
    [AssessmentType.Other]: 'Other',
    [AssessmentType.IReady]: 'iReady',
    [AssessmentType.FountasAndPinnell]: 'Fountas & Pinnell',
    [AssessmentType.GoMath]: 'GoMath'
};

export const assessmentTypesForSubject = (subject) =>
    subject === Subject.Math ? [AssessmentType.GoMath] : [AssessmentType.IReady, AssessmentType.FountasAndPinnell];

export const READING_SCORES = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

// 0 is NT; the rest are percentages. NT counts as not marked.
export const RATINGS = [0, 25, 50, 75, 100];

export const ratingLabel = (rating) => (rating ? `${rating}%` : 'NT');

export const isRated = (rating) => rating !== null && rating !== undefined && rating !== 0;

export const GRADE_ORDER = ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '9-10', '11-12'];

export const sortGrades = (grades) => [...grades].sort((a, b) => GRADE_ORDER.indexOf(a) - GRADE_ORDER.indexOf(b));

// The term's start as a local date. The API sends a date with no time zone, so only the date part is used.
const termStartDay = (term) => (term?.startDate ? parseISO(term.startDate.slice(0, 10)) : null);

// A term that hasn't started can be viewed, but nothing can be saved for it until its first day
export const termNotStarted = (term) => {
    const start = termStartDay(term);
    return Boolean(start) && start > startOfToday();
};

// "January 29"
export const termStartLabel = (term) => {
    const start = termStartDay(term);
    return start ? format(start, 'MMMM d') : '';
};

export const hasScore = (row) => row.assessmentType !== null && row.assessmentType !== undefined && Boolean(row.score);

// One column layout for the header and every student row, so the fields line up across rows and groups.
// Desktop: one line, columns packed to the left and the button on the right in the leftover space.
// Tablet: name with the button, then labelled type and score with goals beside them.
// Phone: the same, but goals drops to its own line.
// Each cell sets its gridArea; the header only shows on desktop.
export const ROW_GRID = {
    display: 'grid',
    gridTemplateColumns: {
        xs: 'minmax(0, 3fr) minmax(0, 2fr)',
        sm: 'minmax(0, 1.2fr) minmax(0, 0.8fr) minmax(0, 1fr)',
        lg: 'minmax(150px, 220px) minmax(140px, 200px) 120px minmax(150px, 1fr) auto'
    },
    gridTemplateAreas: {
        xs: '"student button" "type score" "goals goals"',
        sm: '"student student button" "type score goals"',
        lg: '"student type score goals button"'
    },
    columnGap: { xs: 1.5, lg: 3 },
    rowGap: 1.5,
    alignItems: 'center'
};

// Small buttons are about 31 px high; on phones they get at least 40 px so they're easy to tap
export const PHONE_TAP_TARGET = { minHeight: { xs: 40, sm: 'auto' } };

// "Grade 4", "Grades 4–6", or '' when no student in the group has a grade
export const gradeRangeLabel = (grades) => {
    const sorted = sortGrades([...new Set(grades.filter(Boolean))]);
    if (sorted.length === 0) return '';
    if (sorted.length === 1) return `Grade ${sorted[0]}`;
    return `Grades ${sorted[0]}–${sorted[sorted.length - 1]}`;
};
